"use client";

import { useEffect, useState } from "react"
import { LanguageButton } from "@/ui/atoms/LanguageButton"
import { LanguageList } from "@/ui/molecules/LanguageList"
import { usePathname } from "next/navigation"

export type LanguagePickerProps = {
  buttonClassName?: string
}

export const LanguagePicker: React.FC<LanguagePickerProps> = ({
  buttonClassName,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      return
    }

    const handler = () => {
      setIsOpen(false)
    }

    addEventListener("click", handler)
    return () => removeEventListener("click", handler)
  }, [isOpen])

  const path = usePathname()
  useEffect(() => {
    setIsOpen(false)
  }, [path])

  return (
    <div className="relative">
      <LanguageButton
        className={buttonClassName}
        onClick={(e) => {
          e.stopPropagation()
          setIsOpen((state) => !state)
        }}
        expanded={isOpen}
      />
      {isOpen && <LanguageList />}
    </div>
  )
}
